<app-nav-menu />
<main>
  <router-outlet />
</main>
<app-footer />
